'use client';

import { useState, useEffect } from 'react';

interface Vendedor {
  id: number;
  nome: string;
}

interface MultiSelectVendedoresProps {
  onVendedoresChange: (vendedores: number[]) => void;
  closeVendedoresDropdown: () => void;
}

export function MultiSelectVendedores({ onVendedoresChange, closeVendedoresDropdown }: MultiSelectVendedoresProps) {
  const [vendedores, setVendedores] = useState<Vendedor[]>([]);
  const [selectedVendedores, setSelectedVendedores] = useState<number[]>([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {

    setTimeout(() => {
      closeVendedoresDropdown = () => setIsOpen(false);

    }, 2000)

    fetch('/api/analytics/vendedores')
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setVendedores(data);
        }
      })
      .catch(err => console.error('Error fetching vendedores:', err));
  }, []);

  const handleToggle = (id: number) => {
    const updated = selectedVendedores.includes(id)
      ? selectedVendedores.filter(v => v !== id)
      : [...selectedVendedores, id];
    setSelectedVendedores(updated);
    onVendedoresChange(updated);
  };

  const handleSelectAll = () => {
    if (selectedVendedores.length === vendedores.length) {
      setSelectedVendedores([]);
      onVendedoresChange([]);
    } else {
      const allIds = vendedores.map(v => v.id);
      setSelectedVendedores(allIds);
      onVendedoresChange(allIds);
    }
  };

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-slate-400 mb-2">Vendedores</label>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 rounded-lg bg-slate-700/30 border text-slate-200 text-left flex justify-between items-center"
        style={{ borderColor: 'var(--card-border-bright)', padding: '0.5em 1.5em' }}
      >
        <span>
          {selectedVendedores.length === 0
            ? 'Selecione vendedores...'
            : `${selectedVendedores.length} selecionado(s)`}
        </span>
        <span>{isOpen ? '▼' : '▶'}</span>
      </button>

      {isOpen && (
        <div
          className="absolute top-full left-0 right-0 mt-1 rounded-lg border bg-slate-800 z-50 shadow-lg"
          style={{ borderColor: 'var(--card-border-bright)', padding: '0.5em 1.5em', maxHeight: '200px', overflowY: 'auto' }}
        >
          <div className="p-2 border-b" style={{ borderColor: 'var(--card-border-bright)', padding: '0.5em 1.5em' }}>
            <button
              onClick={handleSelectAll}
              className="w-full px-3 py-2 text-sm rounded hover:bg-slate-700/50 text-left text-slate-200"
            >
              {selectedVendedores.length === vendedores.length ? '✓ Deselecionar Todos' : '☐ Selecionar Todos'}
            </button>
          </div>
          <div className="max-h-64">
            {vendedores.map(v => (
              <label
                style={{
                  marginTop: '0.5em',
                  marginBottom: '0.5em',  
                }}
                key={v.id}
                className="flex items-center px-3 py-2 hover:bg-slate-700/50 cursor-pointer text-slate-200"
              >
                <input
                  type="checkbox"
                  checked={selectedVendedores.includes(v.id)}
                  onChange={() => handleToggle(v.id)}
                  className="mr-2 w-4 h-4"
                  style={{
                    marginRight: '1em'
                  }}
                />
                {v.nome}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
